module.exports = __webpack_public_path__ + "img/if_10.1a992f46.png";